import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../sharedComponent/Header";
import Subheader from "../../sharedComponent/Subheader";
import ic_support from "../../assets/images/ic_support.svg";
import ic_req_ambulance from "../../assets/images/ic_req_ambulance.svg";
import ic_animal_prfl from "../../assets/images/ic_animal_prfl.svg";
import ic_my_apmt from "../../assets/images/ic_my_apmt.svg";
import ic_my_order from "../../assets/images/ic_my_order.svg";
import ic_my_transaction from "../../assets/images/ic_my_transaction.svg";
import ic_my_ac from "../../assets/images/ic_my_ac.svg";
import Star from "../../assets/images/Star.svg";
import BlueImgArow from "../../assets/images/darkIcon.svg";
import liteImgArow from "../../assets/images/lightIcon.svg";
import MyProfileComp from "./MyProfileComp";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import MyAnimalProfileComp from "./MyAnimalProfileComp";
import MyAppointmentsComp from "./MyAppointmentsComp";
// import RequestAmbulancComp from "./RequestAmbulancComp";
import MyTransactionComp from "./DeliveryAddress";
// import SupportComp from "./SupportComp";
import MyOrders from "./MyOrders";
import ApiConfig from "../../api/ApiConfig";
import { simpleGetCall } from "../../api/ApiServices";
import { AppContext } from "../../context/AppContext";
const ProfileSetting = () => {
  const [click, setClick] = useState(false);

const {loginType,setJobApiRefresh} = useContext(AppContext);


const Data = JSON.parse(localStorage.getItem("LOGIN_DATA"));

const handleBookingListClick = ( ) => {
      setJobApiRefresh((prev)=> prev+1);
}
  return (
    <>
      <div className="DoctorsList ProfileSetting" id="cx-main">
        <Subheader />

        <Tab.Container id="left-tabs-example" defaultActiveKey="11">
          <div className="row wrapper gx-3">
            <div className="col-md-3">
              <div className="left-section wrapper-cards">
                <Nav variant="pills" className="flex-column"
                 onSelect={(selectedKey) => {
    if (selectedKey == "66") {
      // handleBookingListClick();   // call only if switching
    }
  }}
                >
                  <Nav.Item>
                    <Nav.Link eventKey="11">
                      <div className="menu-wrapper b-b">
                        <Link>
                          <img src={ic_my_ac} alt="" />
                          My Profile
                        </Link>
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                 
                 
                 
                  <Nav.Item>
                    <Nav.Link eventKey="55">
                      <div className="menu-wrapper b-b count-main">
                        <Link>
                          <img src={ic_my_order} alt="" />
                          My Orders
                        </Link>
                        {/* <div className="count">5</div> */}
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                  {(loginType === 'Agent' || loginType === 'agent') && (
                  <Nav.Item>
                    <Nav.Link eventKey="66">
                      <div className="menu-wrapper b-b">
                        <Link >
                          <img src={ic_my_transaction} alt="" />
                        Order List
                        </Link>
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                  ) }
                  
                </Nav>


              </div>
            </div>
            <div className="col-md-9">
              <Tab.Content>
                <Tab.Pane eventKey="11">
                  <MyProfileComp />
                </Tab.Pane>
                <Tab.Pane eventKey="22">
                  <MyAnimalProfileComp />
                </Tab.Pane>
                <Tab.Pane eventKey="33">
                  <MyAppointmentsComp />
                </Tab.Pane>
                <Tab.Pane eventKey="44">
                  {/* <RequestAmbulancComp /> */}
                </Tab.Pane>
                <Tab.Pane eventKey="55">
                  <MyOrders />
                </Tab.Pane>
                <Tab.Pane eventKey="66">
                  <MyTransactionComp />
                </Tab.Pane>
                <Tab.Pane eventKey="77">
            
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    </>
  );
};

export default ProfileSetting;
